import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { FC } from 'react';

const DEFAULT_MESSAGE =
  'No Slot machines match your Filters or Timeframe. Please adjust the Timeframe or Filter to increase the active Slot Machines (EGMs) that can be shown.';

interface NoDetailsNoticeProps {
  message?: string;
}

const NoDetailsNotice: FC<NoDetailsNoticeProps> = ({ message = DEFAULT_MESSAGE }) => (
  <IonGrid className='hot-slot-listing'>
    <IonRow>
      <IonCol className='ion-text-center'>
        <span
          className='no-data-message'
          style={{
            color: 'rgba(255, 255, 255, 0.70)',
            fontFamily: 'Heebo',
            fontSize: '17px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: '-0.24px',
          }}
        >
          {message}
        </span>
      </IonCol>
    </IonRow>
  </IonGrid>
);

export default NoDetailsNotice;
